module.exports = __webpack_public_path__ + "static/media/SharpSansNo2-Bold.b8b65c9d.otf";